export const create = {
  form: {
    code: '担当者 ID',
    name: '担当者名',
    type: 'タイプ',
    submit: '新規追加',
    select: 'セレクト',
    requireCode: 'オペレーターコードを入力してください',
    requireName: 'オペレーター名を入力してください',
    requireType: '顧客タイプを入力してください',
  },
  pageHeader: {
    title: '担当者新規追加',
    back: '戻る',
  },
}
